import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const PsychosomatikPage = () => {
  return (
    <Layout>
      <PageHero
        title="Psychosomatik: Wenn Körper und Seele im Ungleichgewicht sind"
        subtitle="Wir bieten Ihnen Unterstützung bei seelischen Belastungen, die sich auf Ihre körperliche Gesundheit auswirken."
        backgroundImage="/images/Psychosomatik.webp"
        ctaText="Psychosomatik-Termin vereinbaren"
      />

      <ContentSection
        title="Ganzheitliche Betrachtung Ihrer Gesundheit"
        content="Körperliche Symptome können oft durch seelische Belastungen, Stress oder psychische Probleme ausgelöst oder verstärkt werden. In unserer psychosomatischen Sprechstunde betrachten wir die Wechselwirkungen zwischen Körper und Psyche. Wir helfen Ihnen, die Ursachen Ihrer Beschwerden zu verstehen und entwickeln gemeinsam Lösungsansätze."
        image="/images/Psychosomatik.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Psychosomatische Beratung in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet professionelle Unterstützung bei psychosomatischen Beschwerden und hilft Ihnen, das Gleichgewicht zwischen Körper und Seele wiederherzustellen."
      />

      <CTASection
        title="Fühlen Sie sich belastet oder haben Sie seelische Beschwerden?"
        subtitle="Zögern Sie nicht, professionelle Hilfe in Anspruch zu nehmen. Vereinbaren Sie einen Gesprächstermin."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default PsychosomatikPage;
